import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            if ($(".contract-page").length) {
                gsap.to(".contract-page .contract-container h2", {
                    y: 0,
                    opacity: 1,
                    delay: 0.6,
                    duration: 0.8,
                    ease: defaultEase
                })

                setTimeout(() => {
                    $(".contract-page .contract-container p").each(function () {
                        gsap.to($(this), {
                            y: 0,
                            opacity: 1,
                            duration: 0.6,
                            ease: defaultEase,

                            scrollTrigger: {
                                start: $(this).offset().top + " bottom",
                            }
                        })
                    })

                    $(".contract-page .contract-container ul").each(function () {
                        gsap.to($(this).find("li"), {
                            y: 0,
                            opacity: 1,
                            stagger: 0.1,
                            duration: 0.6,
                            ease: defaultEase,

                            scrollTrigger: {
                                start: $(this).offset().top + " bottom",
                            }
                        })
                    })
                }, 800);
            }
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });
})